(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tpv-purchase-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tpv-purchase-options')) {
  customElements.define('tpv-purchase-options', class extends HTMLElement {
    connectedCallback() {
      const form = this.closest('form');
      if (!form) return;
      this.update = () => {
        const selected = form.querySelector('[data-selected-variant]');
        if (!selected) return;
        let variant;
        try { variant = JSON.parse(selected.textContent); } catch { return; }
        const id = variant && String(variant.id);
        let found = false;
        this.querySelectorAll('[data-notice-variant]').forEach(panel => {
          panel.hidden = panel.dataset.noticeVariant !== id;
          if (!panel.hidden) found = true;
        });
        const unavailable = this.querySelector('[data-notice-unavailable]');
        if (unavailable) unavailable.hidden = found;
      };
      this.update();
      const options = form.querySelector('.js-product-options');
      if (options) {
        this.observer = new MutationObserver(this.update);
        this.observer.observe(options, {childList:true,subtree:true,characterData:true});
      }
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
